import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';

interface PatronageCategory {
  id: string
  name: string
  icon: string
  count: number
  color: string
  description: string
}

const categories: PatronageCategory[] = [
  {
    id: 'cat_health',
    name: 'Health & Healing',
    icon: 'HeartIcon',
    count: 87,
    color: 'bg-red-100 text-red-700 border-red-200',
    description: 'Physical and mental wellness',
  },
  {
    id: 'cat_travel',
    name: 'Travel & Safety',
    icon: 'GlobeAltIcon',
    count: 45,
    color: 'bg-blue-100 text-blue-700 border-blue-200',
    description: 'Journeys and protection',
  },
  {
    id: 'cat_students',
    name: 'Students & Learning',
    icon: 'AcademicCapIcon',
    count: 52,
    color: 'bg-purple-100 text-purple-700 border-purple-200',
    description: 'Education and wisdom',
  },
  {
    id: 'cat_work',
    name: 'Work & Career',
    icon: 'BriefcaseIcon',
    count: 68,
    color: 'bg-amber-100 text-amber-700 border-amber-200',
    description: 'Professional life',
  },
  {
    id: 'cat_family',
    name: 'Family & Home',
    icon: 'HomeIcon',
    count: 73,
    color: 'bg-green-100 text-green-700 border-green-200',
    description: 'Marriage and parenthood',
  },
  {
    id: 'cat_lost',
    name: 'Lost Causes',
    icon: 'SparklesIcon',
    count: 23,
    color: 'bg-indigo-100 text-indigo-700 border-indigo-200',
    description: 'Desperate situations',
  },
  {
    id: 'cat_animals',
    name: 'Animals & Nature',
    icon: 'GlobeAmericasIcon',
    count: 34,
    color: 'bg-teal-100 text-teal-700 border-teal-200',
    description: 'Pets and ecology',
  },
  {
    id: 'cat_arts',
    name: 'Arts & Music',
    icon: 'MusicalNoteIcon',
    count: 41,
    color: 'bg-pink-100 text-pink-700 border-pink-200',
    description: 'Creative pursuits',
  },
]

export default function PatronageSection() {
  return (
    <section className="py-24 px-6 reveal">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
            Browse by Patronage
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4">
            Find Your Saint
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Search by what you need intercession for - from health to travel to lost items
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <Link
              key={category.id}
              href={`/search-saints?patronage=${category.id}`}
              className="group glass-card p-6 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-2 border-transparent hover:border-primary/20"
            >
              <div className={`w-14 h-14 rounded-xl ${category.color} border flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <Icon name={category.icon as any} size={28} />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                {category.name}
              </h3>
              <p className="text-sm text-muted-foreground mb-3">
                {category.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-primary">
                  {category.count} saints
                </span>
                <Icon
                  name="ArrowRightIcon"
                  size={16}
                  className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all"
                />
              </div>
            </Link>
          ))}
        </div>

        {/* View All Categories */}
        <div className="text-center mt-12">
          <Link
            href="/search-saints"
            className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all"
          >
            <span>View All Categories</span>
            <Icon name="ArrowRightIcon" size={20} />
          </Link>
        </div>
      </div>
    </section>
  )
}